//Aqui se defiene las variables para el control y manejo de los input
export const optionClient = [
    { id: 0, name: 'Hogar' },
    { id: 1, name: 'Empresa' },
]

export const initialForm = {
    selectDoc: '',
    typeDoc: '',
    password: '',
}


export const optionDoc = [
    { id: 0, name: 'RIF' },
    { id: 1, name: 'CI' },
]


